import { Controller } from '@hotwired/stimulus';

/**
 * Records an order issue alongside a Care card's click, whether that click
 * opens chat or follows a mailto. Never blocks or cancels the click — it
 * only piggybacks a fire-and-forget report onto it, the same CSRF pattern as
 * pipe17_stranded_order_report_controller.js.
 */
export default class extends Controller {
  static values = { url: String, orderId: String, tags: Array, fields: Array };

  /**
   * Posts the order id once per page load; the server is idempotent, so a
   * second click (a retried mailto, a double chat click) is a harmless
   * no-op here too. Also forwards the cancel context to Zendesk messaging,
   * when it has already loaded, before care-chat#open takes over the click.
   */
  record() {
    if (this.recorded) return;
    this.recorded = true;

    const body = new FormData();
    body.append('order_id', this.orderIdValue);

    fetch(this.urlValue, {
      method: 'POST',
      keepalive: true,
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: 'application/json',
      },
      body,
    }).catch(() => {});

    this.sendCareContext();
  }

  /** @returns {void} */
  sendCareContext() {
    if (typeof window.zE !== 'function') return;

    window.zE('messenger:set', 'conversationTags', this.tagsValue);
    if (this.fieldsValue.length > 0) window.zE('messenger:set', 'conversationFields', this.fieldsValue);
  }
}
